import { createFileRoute, redirect } from '@tanstack/react-router'

import { DIALOG_PATHS } from '~/lib/dialogs'

/**
 * Where the readings used to live. The row and its pages are the metrics now — it holds the
 * days the phone counted as well as the body the tape measured — so this address leads to
 * that one rather than 404ing a link somebody bookmarked or shared.
 */
export const Route = createFileRoute('/body')({
  beforeLoad: () => {
    redirect({
      to: '/',
      search: { dialog: 'metrics' },
      throw: true,
      mask: { to: DIALOG_PATHS.metrics },
    })
  },
})
